export const colors = {
  slate: {
    50: "#F7F8F9",
    100: "#EFF1F4",
    200: "#CFD4DB",
    300: "#B8BFCA",
    400: "#8A97A8",
    500: "#64748B",
    600: "#5B6A7E",
    700: "#475263",
    800: "#475263",
    900: "#2A313A",
  },
  zinc: {
    50: "#F9F9FA",
    100: "#EFEFF0",
    200: "#DADADC",
    300: "#C5C5C9",
    400: "#ADADB3",
    500: "#83838C",
    600: "#68686F",
    700: "#505057",
    800: "#3E3E43",
    900: "#2C2C30",
  },
  red: {
    50: "#FEF5F5",
    100: "#FDECEC",
    200: "#FAC5C5",
    300: "#F69999",
    400: "#F26969",
    500: "#EF4444",
    600: "#D93636",
    700: "#AA3030",
    800: "#832525",
    900: "#641D1D ",
  },
  orange: {
    50: "#fff3e6",
    100: "#ffdab0",
    200: "#ffc88a",
    300: "#feaf54",
    400: "#fe9f33",
    500: "#fe8700",
    600: "#e77b00",
    700: "#b46000",
    800: "#8c4a00",
    900: "#6b3900",
  },
  yellow: {
    25: "#FFFCF3",
    50: "#fef9e6",
    100: "#fcebb0",
    150: "#FDEFBF",
    200: "#fae28a",
    300: "#f8d554",
    400: "#f7cd33",
    500: "#f5c000",
    600: "#DFAF00",
    700: "#ae8800",
    800: "#876a00",
    900: "#675100",
  },
  green: {
    50: "#e8f6ed",
    100: "#b7e2c7",
    200: "#94d5ac",
    300: "#63c186",
    400: "#45b56e",
    500: "#16a34a",
    600: "#149443",
    700: "#107435",
    800: "#0c5a29",
    900: "#09441f",
  },
  purple: {
    50: "#f1ebfe",
    100: "#efe8fe",
    200: "#c0a1fa",
    300: "#a476f8",
    400: "#925cf7",
    500: "#7733f5",
    600: "#6c2edf",
    700: "#5424ae",
    800: "#411c87",
    900: "#321567",
  },
  pink: {
    50: "#fdedf5",
    100: "#f9c6df",
    200: "#f6abd0",
    300: "#f284bb",
    400: "#f06dad",
    500: "#ec4899",
    600: "#d7428b",
    700: "#a8336d",
    800: "#822854",
    900: "#631e40",
  },

  // Special semantic colors
  white: "#fefefe",
  black: "#141414",
  textGrey: "#505057",
  textBlack: "#1F1F20",
  bgLightGrey: "#F3F4F6",
};
